import {
  REQUEST_JOBREQUESTS,
  RESPONSE_JOBREQUESTS,
  REQUEST_JOBREQUESTS_FAILURE,
  SET_JOBREQUESTS_FILTER,
  REQUEST_CREATE_JOBREQUESTS,
  RESPONSE_CREATE_JOBREQUESTS,
  REQUEST_CREATE_JOBREQUESTS_FAILURE,
  REQUEST_DELETE_JOBREQUESTS,
  RESPONSE_DELETE_JOBREQUESTS,
  REQUEST_DELETE_JOBREQUESTS_FAILURE,
  SELECT_JOBREQUESTS,
} from "../actions/jobRequestActions";

import { states } from "./queriesStates";

const initialState = {
  jobRequestsDataState: states.NOT_REQUESTED,
  createJobRequestsDataState: states.NOT_REQUESTED,
  deleteJobRequestsDataState: states.NOT_REQUESTED,
  jobRequestsFull: [],
  jobRequests: [],
  jobRequestsFilter: {
    jobRequestType: -1,
    isWinter: false,
  },
  selectJobRequest: null,
  errors: [],
};

const filter = (jobRequests, filter) => {
  return jobRequests
    .filter((x) => {
      return filter.isWinter === x.isWinter;
    })
    .filter((x) => {
      return filter.jobRequestType === -1 || filter.jobRequestType === x.jobRequestType;
    });
};

const jobRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_JOBREQUESTS:
      return Object.assign({}, state, {
        jobRequestsDataState: states.REQUEST,
      });
    case RESPONSE_JOBREQUESTS:
      return Object.assign({}, state, {
        jobRequestsDataState: states.READY,
        jobRequestsFull: action.data.jobRequests,
        jobRequests: filter(action.data.jobRequests, state.jobRequestsFilter),
      });
    case REQUEST_JOBREQUESTS_FAILURE:
      return Object.assign({}, state, {
        jobRequestsDataState: states.FAILURE,
        errors: action.errors,
      });

    case SET_JOBREQUESTS_FILTER:
      return Object.assign({}, state, {
        jobRequestsFilter: action.data,
        jobRequests: filter(state.jobRequestsFull, action.data),
      });

    case SELECT_JOBREQUESTS:
      const jobRequestsFilter = {
        jobRequestType: state.jobRequestsFilter.jobRequestType === -1 ? 0 : state.jobRequestsFilter.jobRequestType,
        isWinter: state.jobRequestsFilter.isWinter,
      };

      return Object.assign({}, state, {
        selectJobRequest: action.data,
        jobRequestsFilter: jobRequestsFilter,
        jobRequests: filter(state.jobRequestsFull, jobRequestsFilter),
      });

    case REQUEST_CREATE_JOBREQUESTS:
      return Object.assign({}, state, {
        createJobRequestsDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_JOBREQUESTS:
      const jobRequest = { ...action.data, ...state.selectJobRequest };
      const jobRequestsFull = [jobRequest].concat(state.jobRequestsFull);

      return Object.assign({}, state, {
        createJobRequestsDataState: states.READY,
        jobRequestsFull: jobRequestsFull,
        jobRequests: filter(jobRequestsFull, state.jobRequestsFilter),
        selectJobRequest: null,
      });
    case REQUEST_CREATE_JOBREQUESTS_FAILURE:
      return Object.assign({}, state, {
        createJobRequestsDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_JOBREQUESTS:
      return Object.assign({}, state, {
        deleteJobRequestsDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_JOBREQUESTS:
      const _jobRequestsFull = state.jobRequestsFull.filter((x) => {
        return x.id !== action.data.id;
      });

      return Object.assign({}, state, {
        deleteJobRequestsDataState: states.READY,
        jobRequestsFull: _jobRequestsFull,
        jobRequests: filter(_jobRequestsFull, state.jobRequestsFilter),
        selectJobRequest: null,
      });
    case REQUEST_DELETE_JOBREQUESTS_FAILURE:
      return Object.assign({}, state, {
        deleteJobRequestsDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default jobRequestsReducer;
